import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ValidationErrors } from '@angular/forms';
import { Observable } from 'rxjs';
import { FormattingService } from './formatting.service';

@Injectable({
	providedIn: 'root'
})
export class FormsValidationErrorsTextService {

	constructor (private translate: TranslateService) { }

	async getText(errors: ValidationErrors | null | undefined): Promise<string | undefined> {
		let res: Observable<string> | undefined;

		if (errors) {
			if (errors['cassGenericValidationError']) {
				res = this.translate.get(errors['cassGenericValidationError'].translationKey, errors['cassGenericValidationError'].interpolateParams);
			}
			else if (errors['cassImageRequired']) {
				// Angular automatically adds a default required validator if the control is marked as required on the form,
				// so the "cassImageRequired" error should be processed before the embedded "required" one
				res = this.translate.get("FORMS_FIELDS_VALIDATION_ERRORS.IMAGE_REQUIRED");
			}
			else if (errors['required']) {
				res = this.translate.get("FORMS_FIELDS_VALIDATION_ERRORS.VALUE_REQUIRED");
			}
			else if (errors['pattern']) {
				res = this.translate.get("FORMS_FIELDS_VALIDATION_ERRORS.PATTERN_VIOLATION");
			}
			else if (errors['email']) {
				res = this.translate.get("FORMS_FIELDS_VALIDATION_ERRORS.INVALID_EMAIL");
			}
			else if (errors['maxlength']) {
				res = this.translate.get("FORMS_FIELDS_VALIDATION_ERRORS.TEXT_TOO_LONG",
					{
						actual: errors['maxlength'].actualLength,
						max: errors['maxlength'].requiredLength,
						diff: errors['maxlength'].actualLength - errors['maxlength'].requiredLength
					});
			}
			else if (errors['minlength']) {
				res = this.translate.get("FORMS_FIELDS_VALIDATION_ERRORS.TEXT_TOO_SHORT",
					{
						actual: errors['minlength'].actualLength,
						min: errors['minlength'].requiredLength,
						diff: errors['minlength'].requiredLength - errors['minlength'].actualLength
					});
			}
			else if (errors['cassMaxContentSize']) {
				res = this.translate.get("FORMS_FIELDS_VALIDATION_ERRORS.FILE_TOO_BIG", { maxsize: FormattingService.formatFileSize(errors['cassMaxContentSize'].maxSize) });
			}
			else if (errors['passwordsDoNotMatch']) {
				res = this.translate.get("FORMS_FIELDS_VALIDATION_ERRORS.PASSWORDS_DO_NOT_MATCH");
			}
			else {
				res = this.translate.get("ERRORS.UNKNOWN_ERROR");
			}
		}

		return await res?.toPromise();
	}
}
